import {
  LastArticlesSlider,
  LastArticlesSliderProps,
} from '../LastArticlesSlider';

import { ARTICLE_PAGE_SIZE } from '@features/articles/constants';
import { articlesApi } from '@features/articles/store';
import { FC, memo } from 'react';

interface LastArticlesSliderAdapterProps
  extends Omit<LastArticlesSliderProps, 'data'> {}

const _LastArticlesSliderAdapter: FC<LastArticlesSliderAdapterProps> = (
  props,
) => {
  const { ...restProps } = props;

  const { data } = articlesApi.useGetArticlesPageQuery({
    page: 1,
    perPage: ARTICLE_PAGE_SIZE,
  });

  return <LastArticlesSlider data={data?.result || []} {...restProps} />;
};

export const LastArticlesSliderAdapter = memo(_LastArticlesSliderAdapter);
